import React, {useState} from 'react';
import {useRouter} from "next/router";
import styles from "../../../assets/css/register.module.css";
import ButtonLoading from "../../buttonLoading";
import Link from "next/link";
import {handleSubmitPhone} from "./services";
import useTranslation from 'next-translate/useTranslation';


const VerifyPhone = () => {
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';
    const router = useRouter();
    const args = router.query;
    const [input, setInput] = useState({
        CellPhoneNum: "",
    });
    const [serverResponse, setServerResponse] = useState(null)
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState("Please enter your cellphone number");
    const [titleّFa, setTitleFa] = useState("لطفا برای دریافت کد ورود، شماره همراه خود را وارد کنید");

    const handleChange = ({target: {name, value, checked, type}}) => {
        setServerResponse(null);
        setError(null);
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    return (
        <div className={styles.register}>
            <div className={styles.container}>
                <p className={`mt-3 mb-3 ${styles.darkBlue} ${styles.title}`}>
                    {/*Verify Phone Number*/}
                </p>
                <form>
                    {serverResponse?.en && <label className={styles.rtl}>{isRTL ? serverResponse.fa : serverResponse.en}</label>}
                    <label className={'pl-4 pr-4'}> {serverResponse ? '' : (isRTL ? titleّFa : title)} </label>
                    <label
                        className={styles.formError}>{error?.CellPhoneNum ? (isRTL ? error.CellPhoneNumFa : error.CellPhoneNum) : ""}</label>
                    <input
                        className={`${styles.form} form-control d-inline-block ${error && error.CellPhoneNum ? styles.isInvalid : "is-valid"}`}
                        placeholder={isRTL ? 'تلفن همراه' : 'Phone number'}
                        onChange={handleChange}
                        value={input.CellPhoneNum}
                        name="CellPhoneNum"
                        id="mobile-icon"
                        type="tel"
                        style={{fontFamily:isRTL?"Yekan":"Helvetica",textAlign:isRTL?"right":"left",textIndent:isRTL?"0":40}}
                        // style={{ isRTL ? (fontFamily:"Yekan",textAlign:"right",textIndent:0) : (fontFamily:"Helvetica",textAlign:"left") }}
                    />
                    <button
                        type="submit"
                        disabled={loading}
                        className={['mt-4', styles.registerBtn, loading ? styles.disable : ''].join(' ')}
                        onClick={loading ? undefined : (e)=>handleSubmitPhone(e,setError,setServerResponse,input,setLoading,setTitle,setTitleFa,args)}
                    >
                        {loading ? (
                            <>
                                <ButtonLoading/>
                                <span>loading</span>
                            </>
                        ) : (

                            <>{t('verifyPhone:Submit')}</>
                        )}
                    </button>
                    <p className={`${styles.darkBlue} pt-1 mb-1`}>{t("verifyPhone:or")}</p>
                    <Link href="/loginWithKanoon">
                        <a>
                            <button className={`btn ${styles.kanoonBtn} mb-5`}>{t('verifyPhone:kanoonLoginBtn')}</button>
                        </a>
                    </Link>
                </form>
            </div>
        </div>
    );
};

export default VerifyPhone;